export const calculatePercent = (value: number, total: number): number => {
  if (total <= 0) return value > 0 ? 100 : 0;

  return Math.min(Math.max((value / total) * 100, 0), 100);
};
